import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-64a9947c")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex cursor-pointer relative" }, [
  /*#__PURE__*/_createElementVNode("p", {
    style: {"font-weight":"300","font-size":"0.875rem"},
    class: "toggle-link"
  }, "...")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-48" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "app-nav-other-item",
    href: "https://github.com/wavelength-velas",
    target: "_blank"
  }, " Github "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "app-nav-other-item",
    href: "https://twitter.com/Wavelength_DAO",
    target: "_blank"
  }, " Twitter "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "app-nav-other-item",
    href: "https://medium.com/@Wavelength_DAO",
    target: "_blank"
  }, " Medium "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "app-nav-other-item",
    href: "https://discord.gg/YE44J8fxbh",
    target: "_blank"
  }, " Discord "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "app-nav-other-item",
    href: "https://t.me/WavelengthDAO",
    target: "_blank"
  }, " Telegram ")
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalPopover = _resolveComponent("BalPopover")!

  return (_openBlock(), _createBlock(_component_BalPopover, {
    "no-pad": "",
    align: "left"
  }, {
    activator: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _hoisted_2
    ]),
    _: 1
  }))
}